import React from "react"
import { AppSelectionBar, AppSelectionBarButton, AppSelectionBarDivider, AppSelectionBarMenu } from "@components"

import { REPORT_STATUS } from "@constants"
import { MULTIPLE_OPTIONS } from "Pages/ReportsAlerts/Reports/@constants"
import { useReportMultipleList } from "Pages/ReportsAlerts/Reports/@hooks"


export default function ReportListTableCustomToolbarSelect({ selectedData, setSelectedRows }) {
	const {
		handleClickMultipleOption,
		handlePerformMultipleExecutions,
		handleStopMultipleExecutions,
		handleMultipleClone,
		handleClickMultipleDelete,
		handleClickMultipleDisable,
		handleClickMultipleEnable
	} = useReportMultipleList(selectedData, setSelectedRows)

	return <AppSelectionBar
		data-tour-id="tour-multi-bar"
		count={selectedData?.length || 0}
		onClear={() => setSelectedRows([])}
	>
		<AppSelectionBarMenu
			data-tour-id="tour-multi-btn-edit"
			icon="pen-to-square"
			label="Edit"
			items={[{
				'data-tour-id': 'tour-multi-btn-sites',
				icon: 'globe-pointer',
				label: 'Sites',
				onClick: () => handleClickMultipleOption(MULTIPLE_OPTIONS.SITES),
			}, {
				'data-tour-id': 'tour-multi-btn-pickups',
				icon: 'calendars',
				label: 'Pick-up dates',
				hint: 'specific days only',
				onClick: () => handleClickMultipleOption(MULTIPLE_OPTIONS.DATES),
			}, {
				'data-tour-id': 'tour-multi-btn-emails',
				icon: 'envelopes',
				label: 'Emails',
				onClick: () => handleClickMultipleOption(MULTIPLE_OPTIONS.EMAILS),
			}, {
				'data-tour-id': 'tour-multi-btn-frequency',
				icon: 'calendar-clock',
				label: 'Frequency',
				onClick: () => handleClickMultipleOption(MULTIPLE_OPTIONS.FREQUENCY),
			}, {
				'data-tour-id': 'tour-multi-btn-execution-dates',
				icon: 'calendar-lines',
				label: 'Execution date range',
				onClick: () => handleClickMultipleOption(MULTIPLE_OPTIONS.EXECUTION_DATES),
			}]}
		/>
		{selectedData.every(a => a?.enabled) && <AppSelectionBarButton
			data-tour-id="tour-multi-btn-perform"
			icon="gears"
			label="Perform"
			onClick={handlePerformMultipleExecutions}
		/>}
		{selectedData.every(a => a?.statusLastExecution === REPORT_STATUS.RUNNING && a?.enabled) && <AppSelectionBarButton
			data-tour-id="tour-multi-btn-stop"
			icon="circle-stop"
			label="Stop"
			onClick={handleStopMultipleExecutions}
		/>}
		<AppSelectionBarButton
			data-tour-id="tour-multi-btn-copy"
			icon="copy"
			label="Copy"
			onClick={handleMultipleClone}
		/>
		<AppSelectionBarButton
			data-tour-id="tour-multi-btn-enable"
			icon="toggle-on"
			label="Enable"
			onClick={handleClickMultipleEnable}
		/>
		<AppSelectionBarButton
			data-tour-id="tour-multi-btn-disable"
			icon="toggle-off"
			label="Disable"
			onClick={handleClickMultipleDisable}
		/>
		<AppSelectionBarDivider/>
		<AppSelectionBarButton
			data-tour-id="tour-multi-btn-delete"
			icon="trash"
			label="Delete"
			danger
			onClick={handleClickMultipleDelete}
		/>
	</AppSelectionBar>
}
